import lifeInsurance from './lifeInsurance';
import per from './per';
import managementAct from './managementAct';

const types = { lifeInsurance, per, managementAct };

export default types;
